import { AxiosResponse } from "axios";

import { EngageNotificationsModel, EngageNotificationsModelResponse } from "../../types";

const convertNotificationsResponse = ({
	data
}: AxiosResponse<EngageNotificationsModelResponse>): EngageNotificationsModel[] => data.notifications;

export default { convertNotificationsResponse };
